var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-left": "20px" }, attrs: { id: "bm" } },
    [
      _vm.loading
        ? _c("div", { staticClass: "loading" }, [
            _c(
              "div",
              { staticClass: "md-layout md-gutter md-alignment-top-center" },
              [
                _c("md-progress-spinner", {
                  attrs: {
                    "md-diameter": 50,
                    "md-stroke": 5,
                    "md-mode": "indeterminate"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.businessmodel
        ? _c(
            "div",
            [
              _c("div", { staticClass: "md-title md-primary" }, [
                _c("h1", [_vm._v(_vm._s(_vm.businessmodel.name))])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "md-layout md-gutter md-alignment-top-center" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-size-25 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-raised md-accent md-icon-button",
                          on: {
                            click: function($event) {
                              _vm.saveActiveBeforeLeave = true
                            }
                          }
                        },
                        [
                          _c("md-icon", [_vm._v("arrow_back")]),
                          _vm._v(" "),
                          _c(
                            "md-tooltip",
                            { attrs: { "md-direction": "right" } },
                            [_vm._v("Zurück")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass: "md-raised md-accent md-icon-button",
                          on: {
                            click: function($event) {
                              _vm.saveActive = true
                            }
                          }
                        },
                        [
                          _c("md-icon", [_vm._v("save")]),
                          _vm._v(" "),
                          _c(
                            "md-tooltip",
                            { attrs: { "md-direction": "right" } },
                            [_vm._v("Speichern")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass: "md-raised md-accent md-icon-button",
                          on: {
                            click: function($event) {
                              return _vm.exportPDF()
                            }
                          }
                        },
                        [
                          _c("md-icon", [_vm._v("vertical_align_bottom")]),
                          _vm._v(" "),
                          _c(
                            "md-tooltip",
                            { attrs: { "md-direction": "right" } },
                            [_vm._v("Als PDF runterladen")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-button",
                        {
                          staticClass: "md-raised md-accent md-icon-button",
                          on: {
                            click: function($event) {
                              _vm.setRecommendationsActive = true
                            }
                          }
                        },
                        [
                          _c("md-icon", { staticClass: "mirror" }, [
                            _vm._v("wb_incandescent")
                          ]),
                          _vm._v(" "),
                          _c(
                            "md-tooltip",
                            { attrs: { "md-direction": "right" } },
                            [_vm._v("Empfehlungen anzeigen")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass:
                      "md-layout-item md-size-75 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "md-layout md-gutter md-alignment-top-center" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-size-25 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                    },
                    [
                      _c("br"),
                      _vm._v(" "),
                      _vm.checkContinueWithQuestions()
                        ? _c(
                            "md-button",
                            {
                              staticClass: "md-raised md-accent",
                              on: {
                                click: function($event) {
                                  return _vm.continueWithQuestions()
                                }
                              }
                            },
                            [
                              _vm._v("Mit Beantwortung der "),
                              _c("br"),
                              _vm._v("Fragen fortfahren\n        ")
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-size-25 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                    },
                    [
                      _c(
                        "md-switch",
                        {
                          model: {
                            value: _vm.listView,
                            callback: function($$v) {
                              _vm.listView = $$v
                            },
                            expression: "listView"
                          }
                        },
                        [_vm._v("Ansicht wechseln")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              !_vm.listView
                ? _c("div", { attrs: { id: "content" } }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout md-gutter md-alignment-top-center"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-size-20 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "md-layout md-gutter md-alignment-top-center"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "md-layout-item md-size-100",
                                    on: {
                                      click: function($event) {
                                        return _vm.goToBrick(
                                          "Schlüsselpartnerschaften"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "md-card",
                                      {
                                        staticClass:
                                          "tile-done height-adjust-1",
                                        attrs: { "md-with-hover": "" }
                                      },
                                      [
                                        _c("md-card-header", [
                                          _c(
                                            "div",
                                            { staticClass: "md-title" },
                                            [_vm._v("Schlüsselpartner")]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "md-button",
                                          {
                                            staticClass:
                                              "md-fab md-primary md-mini",
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                _vm.currentaspect =
                                                  "Schlüsselpartnerschaften"
                                                _vm.aspecttoadd.brick = true
                                                _vm.customAdd = true
                                              }
                                            }
                                          },
                                          [_c("md-icon", [_vm._v("add")])],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "md-card-content",
                                          _vm._l(
                                            _vm.getSchlusselpartnerschaften(),
                                            function(element) {
                                              return _c(
                                                "div",
                                                { key: element.hash },
                                                [
                                                  _c(
                                                    "md-card",
                                                    {
                                                      staticClass:
                                                        "md-primary custom-chip"
                                                    },
                                                    [
                                                      _c(
                                                        "md-content",
                                                        {
                                                          staticClass:
                                                            "md-primary sfont",
                                                          attrs: {
                                                            align: "center"
                                                          }
                                                        },
                                                        [
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(
                                                                element.name
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            element.children,
                                                            function(item) {
                                                              return _c(
                                                                "span",
                                                                {
                                                                  key: item.hash
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.name
                                                                    ) + ";"
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-size-20 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "md-layout md-gutter md-alignment-top-center"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "md-layout-item md-size-100",
                                    on: {
                                      click: function($event) {
                                        return _vm.goToBrick(
                                          "Schlüsselaktivitäten"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "md-card",
                                      {
                                        staticClass:
                                          "tile-notstarted height-adjust-2",
                                        attrs: { "md-with-hover": "" }
                                      },
                                      [
                                        _c("md-card-header", [
                                          _c(
                                            "div",
                                            { staticClass: "md-title" },
                                            [_vm._v("Schlüsselaktivitäten")]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "md-card-content",
                                          [
                                            _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-fab md-primary md-mini",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.currentaspect =
                                                      "Schlüsselaktivitäten"
                                                    _vm.aspecttoadd.brick = true
                                                    _vm.customAdd = true
                                                  }
                                                }
                                              },
                                              [_c("md-icon", [_vm._v("add")])],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.getSchlusselaktivitaten(),
                                              function(element) {
                                                return _c(
                                                  "div",
                                                  { key: element.hash },
                                                  [
                                                    _c(
                                                      "md-card",
                                                      {
                                                        staticClass:
                                                          "md-primary custom-chip"
                                                      },
                                                      [
                                                        _c(
                                                          "md-content",
                                                          {
                                                            staticClass:
                                                              "md-primary sfont",
                                                            attrs: {
                                                              align: "center"
                                                            }
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  element.name
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("br"),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              element.children,
                                                              function(item) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key:
                                                                      item.hash
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.name
                                                                      ) + ";"
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "md-layout-item md-size-100",
                                    on: {
                                      click: function($event) {
                                        return _vm.goToBrick(
                                          "Schlüsselressourcen"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "md-card",
                                      {
                                        staticClass:
                                          "tile-done height-adjust-2",
                                        attrs: { "md-with-hover": "" }
                                      },
                                      [
                                        _c("md-card-header", [
                                          _c(
                                            "div",
                                            { staticClass: "md-title" },
                                            [_vm._v("Schlüsselressourcen")]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "md-card-content",
                                          [
                                            _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-fab md-primary md-mini",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.currentaspect =
                                                      "Schlüsselressourcen"
                                                    _vm.aspecttoadd.brick = true
                                                    _vm.customAdd = true
                                                  }
                                                }
                                              },
                                              [_c("md-icon", [_vm._v("add")])],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.getSchlusselressourcen(),
                                              function(element) {
                                                return _c(
                                                  "div",
                                                  { key: element.hash },
                                                  [
                                                    _c(
                                                      "md-card",
                                                      {
                                                        staticClass:
                                                          "md-primary custom-chip"
                                                      },
                                                      [
                                                        _c(
                                                          "md-content",
                                                          {
                                                            staticClass:
                                                              "md-primary sfont",
                                                            attrs: {
                                                              align: "center"
                                                            }
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  element.name
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("br"),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              element.children,
                                                              function(item) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key:
                                                                      item.hash
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.name
                                                                      ) + ";"
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-size-20 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "md-layout md-gutter md-alignment-top-center"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "md-layout-item md-size-100",
                                    on: {
                                      click: function($event) {
                                        return _vm.goToBrick("Wertangebot")
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "md-card",
                                      {
                                        staticClass:
                                          "tile-inprogress height-adjust-1",
                                        attrs: { "md-with-hover": "" }
                                      },
                                      [
                                        _c("md-card-header", [
                                          _c(
                                            "div",
                                            { staticClass: "md-title" },
                                            [_vm._v("Wertangebot")]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "md-card-content",
                                          [
                                            _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-fab md-primary md-mini",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.currentaspect =
                                                      "Wertangebot"
                                                    _vm.aspecttoadd.brick = true
                                                    _vm.customAdd = true
                                                  }
                                                }
                                              },
                                              [_c("md-icon", [_vm._v("add")])],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.getWertangebot(),
                                              function(element) {
                                                return _c(
                                                  "div",
                                                  { key: element.hash },
                                                  [
                                                    _c(
                                                      "md-card",
                                                      {
                                                        staticClass:
                                                          "md-primary custom-chip"
                                                      },
                                                      [
                                                        _c(
                                                          "md-content",
                                                          {
                                                            staticClass:
                                                              "md-primary sfont",
                                                            attrs: {
                                                              align: "center"
                                                            }
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  element.name
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("br"),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              element.children,
                                                              function(item) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key:
                                                                      item.hash
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.name
                                                                      ) + ";"
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-size-20 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "md-layout md-gutter md-alignment-top-center"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "md-layout-item md-size-100",
                                    on: {
                                      click: function($event) {
                                        return _vm.goToBrick("Kundenbeziehung")
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "md-card",
                                      {
                                        staticClass:
                                          "tile-done height-adjust-2",
                                        attrs: { "md-with-hover": "" }
                                      },
                                      [
                                        _c("md-card-header", [
                                          _c(
                                            "div",
                                            { staticClass: "md-title" },
                                            [_vm._v("Kundenbeziehung")]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "md-card-content",
                                          [
                                            _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-fab md-primary md-mini",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.currentaspect =
                                                      "Kundenbeziehung"
                                                    _vm.aspecttoadd.brick = true
                                                    _vm.customAdd = true
                                                  }
                                                }
                                              },
                                              [_c("md-icon", [_vm._v("add")])],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.getKundenbeziehung(),
                                              function(element) {
                                                return _c(
                                                  "div",
                                                  { key: element.hash },
                                                  [
                                                    _c(
                                                      "md-card",
                                                      {
                                                        staticClass:
                                                          "md-primary custom-chip"
                                                      },
                                                      [
                                                        _c(
                                                          "md-content",
                                                          {
                                                            staticClass:
                                                              "md-primary sfont",
                                                            attrs: {
                                                              align: "center"
                                                            }
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  element.name
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("br"),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              element.children,
                                                              function(item) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key:
                                                                      item.hash
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.name
                                                                      ) + ";"
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "md-layout-item md-size-100",
                                    on: {
                                      click: function($event) {
                                        return _vm.goToBrick("Kanäle")
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "md-card",
                                      {
                                        staticClass:
                                          "tile-notstarted height-adjust-2",
                                        attrs: { "md-with-hover": "" }
                                      },
                                      [
                                        _c("md-card-header", [
                                          _c(
                                            "div",
                                            { staticClass: "md-title" },
                                            [_vm._v("Kanäle")]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "md-card-content",
                                          [
                                            _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-fab md-primary md-mini",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.currentaspect = "Kanäle"
                                                    _vm.aspecttoadd.brick = true
                                                    _vm.customAdd = true
                                                  }
                                                }
                                              },
                                              [_c("md-icon", [_vm._v("add")])],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm._l(_vm.getKanale(), function(
                                              element
                                            ) {
                                              return _c(
                                                "div",
                                                { key: element.hash },
                                                [
                                                  _c(
                                                    "md-card",
                                                    {
                                                      staticClass:
                                                        "md-primary custom-chip"
                                                    },
                                                    [
                                                      _c(
                                                        "md-content",
                                                        {
                                                          staticClass:
                                                            "md-primary sfont",
                                                          attrs: {
                                                            align: "center"
                                                          }
                                                        },
                                                        [
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(
                                                                element.name
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _vm._l(
                                                            element.children,
                                                            function(item) {
                                                              return _c(
                                                                "span",
                                                                {
                                                                  key: item.hash
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.name
                                                                    ) + ";"
                                                                  )
                                                                ]
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        2
                                                      )
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            })
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-size-20 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "md-layout md-gutter md-alignment-top-center"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "md-layout-item md-size-100",
                                    on: {
                                      click: function($event) {
                                        return _vm.goToBrick("Kundensegment")
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "md-card",
                                      {
                                        staticClass:
                                          "tile-inprogress height-adjust-1",
                                        attrs: { "md-with-hover": "" }
                                      },
                                      [
                                        _c("md-card-header", [
                                          _c(
                                            "div",
                                            { staticClass: "md-title" },
                                            [_vm._v("Kundensegment")]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "md-card-content",
                                          [
                                            _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-fab md-primary md-mini",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.currentaspect =
                                                      "Kundensegment"
                                                    _vm.aspecttoadd.brick = true
                                                    _vm.customAdd = true
                                                  }
                                                }
                                              },
                                              [_c("md-icon", [_vm._v("add")])],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.getKundensegment(),
                                              function(element) {
                                                return _c(
                                                  "div",
                                                  { key: element.hash },
                                                  [
                                                    _c(
                                                      "md-card",
                                                      {
                                                        staticClass:
                                                          "md-primary custom-chip"
                                                      },
                                                      [
                                                        _c(
                                                          "md-content",
                                                          {
                                                            staticClass:
                                                              "md-primary sfont",
                                                            attrs: {
                                                              align: "center"
                                                            }
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  element.name
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("br"),
                                                            _vm._v(" "),
                                                            _vm._l(
                                                              element.children,
                                                              function(item) {
                                                                return _c(
                                                                  "span",
                                                                  {
                                                                    key:
                                                                      item.hash
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.name
                                                                      ) + ";"
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout md-gutter md-alignment-top-center"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "md-layout md-gutter md-alignment-top-center"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "md-layout-item md-size-100",
                                    on: {
                                      click: function($event) {
                                        return _vm.goToBrick("Kostenstruktur")
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "md-card",
                                      {
                                        staticClass:
                                          "tile-notstarted height-adjust-2",
                                        attrs: { "md-with-hover": "" }
                                      },
                                      [
                                        _c("md-card-header", [
                                          _c(
                                            "div",
                                            { staticClass: "md-title" },
                                            [_vm._v("Kostenstruktur")]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "md-card-content",
                                          [
                                            _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-fab md-primary md-mini",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.currentaspect =
                                                      "Kostenstruktur"
                                                    _vm.aspecttoadd.brick = true
                                                    _vm.customAdd = true
                                                  }
                                                }
                                              },
                                              [_c("md-icon", [_vm._v("add")])],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "md-layout md-gutter md-alignment-top-center"
                                              },
                                              _vm._l(
                                                _vm.getKostenstruktur(),
                                                function(element) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: element.hash,
                                                      staticClass:
                                                        "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                                    },
                                                    [
                                                      _c(
                                                        "md-card",
                                                        {
                                                          staticClass:
                                                            "md-primary custom-chip"
                                                        },
                                                        [
                                                          _c(
                                                            "md-content",
                                                            {
                                                              staticClass:
                                                                "md-primary sfont",
                                                              attrs: {
                                                                align: "center"
                                                              }
                                                            },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    element.name
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("br"),
                                                              _vm._v(" "),
                                                              _vm._l(
                                                                element.children,
                                                                function(item) {
                                                                  return _c(
                                                                    "span",
                                                                    {
                                                                      key:
                                                                        item.hash
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.name
                                                                        ) + ";"
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            ],
                                                            2
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "md-layout md-gutter md-alignment-top-center"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "md-layout-item md-size-100",
                                    on: {
                                      click: function($event) {
                                        return _vm.goToBrick("Einnahmequellen")
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "md-card",
                                      {
                                        staticClass:
                                          "tile-notstarted height-adjust-2",
                                        attrs: { "md-with-hover": "" }
                                      },
                                      [
                                        _c("md-card-header", [
                                          _c(
                                            "div",
                                            { staticClass: "md-title" },
                                            [_vm._v("Einnahmequellen")]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "md-card-content",
                                          [
                                            _c(
                                              "md-button",
                                              {
                                                staticClass:
                                                  "md-fab md-primary md-mini",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    _vm.currentaspect =
                                                      "Einnahmequellen"
                                                    _vm.aspecttoadd.brick = true
                                                    _vm.customAdd = true
                                                  }
                                                }
                                              },
                                              [_c("md-icon", [_vm._v("add")])],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "md-layout md-gutter md-alignment-top-center"
                                              },
                                              _vm._l(
                                                _vm.getEinnahmequellen(),
                                                function(element) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: element.hash,
                                                      staticClass:
                                                        "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                                    },
                                                    [
                                                      _c(
                                                        "md-card",
                                                        {
                                                          staticClass:
                                                            "md-primary custom-chip"
                                                        },
                                                        [
                                                          _c(
                                                            "md-content",
                                                            {
                                                              staticClass:
                                                                "md-primary sfont",
                                                              attrs: {
                                                                align: "center"
                                                              }
                                                            },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    element.name
                                                                  )
                                                                )
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("br"),
                                                              _vm._v(" "),
                                                              _vm._l(
                                                                element.children,
                                                                function(item) {
                                                                  return _c(
                                                                    "span",
                                                                    {
                                                                      key:
                                                                        item.hash
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.name
                                                                        ) + ";"
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              )
                                                            ],
                                                            2
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.listView
                ? _c("div", { attrs: { id: "content" } }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout md-gutter md-alignment-top-center"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "md-layout-item md-size-100",
                            on: {
                              click: function($event) {
                                return _vm.goToBrick("Schlüsselpartnerschaften")
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                staticClass: "tile-done height-adjust-2",
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c("md-card-header", [
                                  _c("div", { staticClass: "md-title" }, [
                                    _vm._v("Schlüsselpartner")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "md-card-content",
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-fab md-primary md-mini",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.currentaspect =
                                              "Schlüsselpartnerschaften"
                                            _vm.aspecttoadd.brick = true
                                            _vm.customAdd = true
                                          }
                                        }
                                      },
                                      [_c("md-icon", [_vm._v("add")])],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "md-layout md-gutter md-alignment-top-center"
                                      },
                                      _vm._l(
                                        _vm.getSchlusselpartnerschaften(),
                                        function(element) {
                                          return _c(
                                            "div",
                                            {
                                              key: element.hash,
                                              staticClass:
                                                "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                            },
                                            [
                                              _c(
                                                "md-card",
                                                {
                                                  staticClass:
                                                    "md-primary custom-chip"
                                                },
                                                [
                                                  _c(
                                                    "md-content",
                                                    {
                                                      staticClass:
                                                        "md-primary sfont",
                                                      attrs: { align: "center" }
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(element.name)
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        element.children,
                                                        function(item) {
                                                          return _c(
                                                            "span",
                                                            { key: item.hash },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                ) + ";"
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "md-layout-item md-size-100",
                            on: {
                              click: function($event) {
                                return _vm.goToBrick("Schlüsselaktivitäten")
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                staticClass: "tile-notstarted height-adjust-2",
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c("md-card-header", [
                                  _c("div", { staticClass: "md-title" }, [
                                    _vm._v("Schlüsselaktivitäten")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "md-card-content",
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-fab md-primary md-mini",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.currentaspect =
                                              "Schlüsselaktivitäten"
                                            _vm.aspecttoadd.brick = true
                                            _vm.customAdd = true
                                          }
                                        }
                                      },
                                      [_c("md-icon", [_vm._v("add")])],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "md-layout md-gutter md-alignment-top-center"
                                      },
                                      _vm._l(
                                        _vm.getSchlusselaktivitaten(),
                                        function(element) {
                                          return _c(
                                            "div",
                                            {
                                              key: element.hash,
                                              staticClass:
                                                "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                            },
                                            [
                                              _c(
                                                "md-card",
                                                {
                                                  staticClass:
                                                    "md-primary custom-chip"
                                                },
                                                [
                                                  _c(
                                                    "md-content",
                                                    {
                                                      staticClass:
                                                        "md-primary sfont",
                                                      attrs: { align: "center" }
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(element.name)
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        element.children,
                                                        function(item) {
                                                          return _c(
                                                            "span",
                                                            { key: item.hash },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                ) + ";"
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "md-layout-item md-size-100",
                            on: {
                              click: function($event) {
                                return _vm.goToBrick("Schlüsselressourcen")
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                staticClass: "tile-done height-adjust-2",
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c("md-card-header", [
                                  _c("div", { staticClass: "md-title" }, [
                                    _vm._v("Schlüsselressourcen")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "md-card-content",
                                  { staticClass: "md-scrollbar" },
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-fab md-primary md-mini",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.currentaspect =
                                              "Schlüsselressourcen"
                                            _vm.aspecttoadd.brick = true
                                            _vm.customAdd = true
                                          }
                                        }
                                      },
                                      [_c("md-icon", [_vm._v("add")])],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "md-layout md-gutter md-alignment-top-center"
                                      },
                                      _vm._l(
                                        _vm.getSchlusselressourcen(),
                                        function(element) {
                                          return _c(
                                            "div",
                                            {
                                              key: element.hash,
                                              staticClass:
                                                "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                            },
                                            [
                                              _c(
                                                "md-card",
                                                {
                                                  staticClass:
                                                    "md-primary custom-chip"
                                                },
                                                [
                                                  _c(
                                                    "md-content",
                                                    {
                                                      staticClass:
                                                        "md-primary sfont",
                                                      attrs: { align: "center" }
                                                    },
                                                    [
                                                      _c("strong", [
                                                        _vm._v(
                                                          _vm._s(element.name)
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("br"),
                                                      _vm._v(" "),
                                                      _vm._l(
                                                        element.children,
                                                        function(item) {
                                                          return _c(
                                                            "span",
                                                            { key: item.hash },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.name
                                                                ) + ";"
                                                              )
                                                            ]
                                                          )
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "md-layout-item md-size-100",
                            on: {
                              click: function($event) {
                                return _vm.goToBrick("Wertangebot")
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                staticClass: "tile-inprogress height-adjust-2",
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c("md-card-header", [
                                  _c("div", { staticClass: "md-title" }, [
                                    _vm._v("Wertangebot")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "md-card-content",
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-fab md-primary md-mini",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.currentaspect = "Wertangebot"
                                            _vm.aspecttoadd.brick = true
                                            _vm.customAdd = true
                                          }
                                        }
                                      },
                                      [_c("md-icon", [_vm._v("add")])],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "md-layout md-gutter md-alignment-top-center"
                                      },
                                      _vm._l(_vm.getWertangebot(), function(
                                        element
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: element.hash,
                                            staticClass:
                                              "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                          },
                                          [
                                            _c(
                                              "md-card",
                                              {
                                                staticClass:
                                                  "md-primary custom-chip"
                                              },
                                              [
                                                _c(
                                                  "md-content",
                                                  {
                                                    staticClass:
                                                      "md-primary sfont",
                                                    attrs: { align: "center" }
                                                  },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(element.name)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      element.children,
                                                      function(item) {
                                                        return _c(
                                                          "span",
                                                          { key: item.hash },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.name
                                                              ) + ";"
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "md-layout-item md-size-100",
                            on: {
                              click: function($event) {
                                return _vm.goToBrick("Kundenbeziehung")
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                staticClass: "tile-done height-adjust-2",
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c("md-card-header", [
                                  _c("div", { staticClass: "md-title" }, [
                                    _vm._v("Kundenbeziehung")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "md-card-content",
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-fab md-primary md-mini",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.currentaspect =
                                              "Kundenbeziehung"
                                            _vm.aspecttoadd.brick = true
                                            _vm.customAdd = true
                                          }
                                        }
                                      },
                                      [_c("md-icon", [_vm._v("add")])],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "md-layout md-gutter md-alignment-top-center"
                                      },
                                      _vm._l(_vm.getKundenbeziehung(), function(
                                        element
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: element.hash,
                                            staticClass:
                                              "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                          },
                                          [
                                            _c(
                                              "md-card",
                                              {
                                                staticClass:
                                                  "md-primary custom-chip"
                                              },
                                              [
                                                _c(
                                                  "md-content",
                                                  {
                                                    staticClass:
                                                      "md-primary sfont",
                                                    attrs: { align: "center" }
                                                  },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(element.name)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      element.children,
                                                      function(item) {
                                                        return _c(
                                                          "span",
                                                          { key: item.hash },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.name
                                                              ) + ";"
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "md-layout-item md-size-100",
                            on: {
                              click: function($event) {
                                return _vm.goToBrick("Kanäle")
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                staticClass: "tile-notstarted height-adjust-2",
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c("md-card-header", [
                                  _c("div", { staticClass: "md-title" }, [
                                    _vm._v("Kanäle")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "md-card-content",
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-fab md-primary md-mini",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.currentaspect = "Kanäle"
                                            _vm.aspecttoadd.brick = true
                                            _vm.customAdd = true
                                          }
                                        }
                                      },
                                      [_c("md-icon", [_vm._v("add")])],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "md-layout md-gutter md-alignment-top-center"
                                      },
                                      _vm._l(_vm.getKanale(), function(
                                        element
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: element.hash,
                                            staticClass:
                                              "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                          },
                                          [
                                            _c(
                                              "md-card",
                                              {
                                                staticClass:
                                                  "md-primary custom-chip"
                                              },
                                              [
                                                _c(
                                                  "md-content",
                                                  {
                                                    staticClass:
                                                      "md-primary sfont",
                                                    attrs: { align: "center" }
                                                  },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(element.name)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      element.children,
                                                      function(item) {
                                                        return _c(
                                                          "span",
                                                          { key: item.hash },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.name
                                                              ) + ";"
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "md-layout-item md-size-100",
                            on: {
                              click: function($event) {
                                return _vm.goToBrick("Kundensegment")
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                staticClass: "tile-inprogress height-adjust-2",
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c("md-card-header", [
                                  _c("div", { staticClass: "md-title" }, [
                                    _vm._v("Kundensegment")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "md-card-content",
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-fab md-primary md-mini",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.currentaspect = "Kundensegment"
                                            _vm.aspecttoadd.brick = true
                                            _vm.customAdd = true
                                          }
                                        }
                                      },
                                      [_c("md-icon", [_vm._v("add")])],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "md-layout md-gutter md-alignment-top-center"
                                      },
                                      _vm._l(_vm.getKundensegment(), function(
                                        element
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: element.hash,
                                            staticClass:
                                              "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                          },
                                          [
                                            _c(
                                              "md-card",
                                              {
                                                staticClass:
                                                  "md-primary custom-chip"
                                              },
                                              [
                                                _c(
                                                  "md-content",
                                                  {
                                                    staticClass:
                                                      "md-primary sfont",
                                                    attrs: { align: "center" }
                                                  },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(element.name)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      element.children,
                                                      function(item) {
                                                        return _c(
                                                          "span",
                                                          { key: item.hash },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.name
                                                              ) + ";"
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "md-layout md-gutter md-alignment-top-center"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "md-layout-item md-size-100",
                            on: {
                              click: function($event) {
                                return _vm.goToBrick("Kostenstruktur")
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                staticClass: "tile-notstarted height-adjust-2",
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c("md-card-header", [
                                  _c("div", { staticClass: "md-title" }, [
                                    _vm._v("Kostenstruktur")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "md-card-content",
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-fab md-primary md-mini",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.currentaspect = "Kostenstruktur"
                                            _vm.aspecttoadd.brick = true
                                            _vm.customAdd = true
                                          }
                                        }
                                      },
                                      [_c("md-icon", [_vm._v("add")])],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "md-layout md-gutter md-alignment-top-center"
                                      },
                                      _vm._l(_vm.getKostenstruktur(), function(
                                        element
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: element.hash,
                                            staticClass:
                                              "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                          },
                                          [
                                            _c(
                                              "md-card",
                                              {
                                                staticClass:
                                                  "md-primary custom-chip"
                                              },
                                              [
                                                _c(
                                                  "md-content",
                                                  {
                                                    staticClass:
                                                      "md-primary sfont",
                                                    attrs: { align: "center" }
                                                  },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(element.name)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      element.children,
                                                      function(item) {
                                                        return _c(
                                                          "span",
                                                          { key: item.hash },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.name
                                                              ) + ";"
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "md-layout-item md-size-100",
                            on: {
                              click: function($event) {
                                return _vm.goToBrick("Einnahmequellen")
                              }
                            }
                          },
                          [
                            _c(
                              "md-card",
                              {
                                staticClass: "tile-notstarted height-adjust-2",
                                attrs: { "md-with-hover": "" }
                              },
                              [
                                _c("md-card-header", [
                                  _c("div", { staticClass: "md-title" }, [
                                    _vm._v("Einnahmequellen")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "md-card-content",
                                  [
                                    _c(
                                      "md-button",
                                      {
                                        staticClass:
                                          "md-fab md-primary md-mini",
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            _vm.currentaspect =
                                              "Einnahmequellen"
                                            _vm.aspecttoadd.brick = true
                                            _vm.customAdd = true
                                          }
                                        }
                                      },
                                      [_c("md-icon", [_vm._v("add")])],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "md-layout md-gutter md-alignment-top-center"
                                      },
                                      _vm._l(_vm.getEinnahmequellen(), function(
                                        element
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: element.hash,
                                            staticClass:
                                              "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                                          },
                                          [
                                            _c(
                                              "md-card",
                                              {
                                                staticClass:
                                                  "md-primary custom-chip"
                                              },
                                              [
                                                _c(
                                                  "md-content",
                                                  {
                                                    staticClass:
                                                      "md-primary sfont",
                                                    attrs: { align: "center" }
                                                  },
                                                  [
                                                    _c("strong", [
                                                      _vm._v(
                                                        _vm._s(element.name)
                                                      )
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("br"),
                                                    _vm._v(" "),
                                                    _vm._l(
                                                      element.children,
                                                      function(item) {
                                                        return _c(
                                                          "span",
                                                          { key: item.hash },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.name
                                                              ) + ";"
                                                            )
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "md-layout md-gutter md-alignment-top-center" },
                [
                  _c("div", {
                    staticClass:
                      "md-layout-item md-size-25 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                    },
                    [
                      _c("br"),
                      _vm._v(" "),
                      _c("span", [_vm._v("Notizen")]),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        {
                          staticStyle: {
                            "background-color": "white !important"
                          }
                        },
                        [
                          _c("md-textarea", {
                            model: {
                              value: _vm.businessmodel.description,
                              callback: function($$v) {
                                _vm.$set(_vm.businessmodel, "description", $$v)
                              },
                              expression: "businessmodel.description"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", {
                    staticClass:
                      "md-layout-item md-size-25 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "md-dialog",
                {
                  attrs: { "md-active": _vm.saveActive },
                  on: {
                    "update:mdActive": function($event) {
                      _vm.saveActive = $event
                    },
                    "update:md-active": function($event) {
                      _vm.saveActive = $event
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { padding: "10px" } },
                    [
                      _c("md-dialog-title", [
                        _c("strong", [_vm._v("Geschäftsmodell speichern")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        [
                          _c("md-input", {
                            attrs: { name: "name", id: "name" },
                            model: {
                              value: _vm.businessmodel.name,
                              callback: function($$v) {
                                _vm.$set(_vm.businessmodel, "name", $$v)
                              },
                              expression: "businessmodel.name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        [
                          _c("md-textarea", {
                            attrs: {
                              name: "notes1",
                              id: "notes1",
                              maxlength: "50",
                              placeholder:
                                "Please enter a maximum of 50 characters"
                            },
                            model: {
                              value: _vm.businessmodel.note,
                              callback: function($$v) {
                                _vm.$set(_vm.businessmodel, "note", $$v)
                              },
                              expression: "businessmodel.note"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-dialog-actions",
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-secondary",
                              on: {
                                click: function($event) {
                                  _vm.saveActive = false
                                }
                              }
                            },
                            [_vm._v("Abbrechen")]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass: "md-primary",
                              on: {
                                click: function($event) {
                                  _vm.saveModel()
                                  _vm.saveActive = false
                                }
                              }
                            },
                            [_vm._v("Speichern")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "md-dialog",
                {
                  attrs: { "md-active": _vm.saveActiveBeforeLeave },
                  on: {
                    "update:mdActive": function($event) {
                      _vm.saveActiveBeforeLeave = $event
                    },
                    "update:md-active": function($event) {
                      _vm.saveActiveBeforeLeave = $event
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticStyle: { padding: "10px" } },
                    [
                      _c("md-dialog-title", [
                        _c("strong", [
                          _vm._v("Geschäftsmodell vor dem Verlassen speichern?")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        [
                          _c("md-input", {
                            attrs: { name: "name", id: "name" },
                            model: {
                              value: _vm.businessmodel.name,
                              callback: function($$v) {
                                _vm.$set(_vm.businessmodel, "name", $$v)
                              },
                              expression: "businessmodel.name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-field",
                        [
                          _c("md-textarea", {
                            attrs: { name: "notes", id: "notes" },
                            model: {
                              value: _vm.businessmodel.note,
                              callback: function($$v) {
                                _vm.$set(_vm.businessmodel, "note", $$v)
                              },
                              expression: "businessmodel.note"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "md-dialog-actions",
                        [
                          _c(
                            "md-button",
                            {
                              staticClass: "md-secondary",
                              on: {
                                click: function($event) {
                                  _vm.saveActiveBeforeLeave = false
                                }
                              }
                            },
                            [_vm._v("Abbrechen")]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass: "md-primary",
                              on: {
                                click: function($event) {
                                  _vm.saveActiveBeforeLeave = false
                                  _vm.goBack()
                                }
                              }
                            },
                            [_vm._v("Nicht Speichern")]
                          ),
                          _vm._v(" "),
                          _c(
                            "md-button",
                            {
                              staticClass: "md raised md-primary",
                              on: {
                                click: function($event) {
                                  _vm.saveActiveBeforeLeave = false
                                  _vm.saveModelAndGoBack()
                                }
                              }
                            },
                            [_vm._v("Speichern")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "md-dialog",
                {
                  attrs: { "md-active": _vm.setRecommendationsActive },
                  on: {
                    "update:mdActive": function($event) {
                      _vm.setRecommendationsActive = $event
                    },
                    "update:md-active": function($event) {
                      _vm.setRecommendationsActive = $event
                    }
                  }
                },
                [
                  _c("md-dialog-content", [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px" } },
                      [
                        _c("h1", [_vm._v("Technologieempfehlungen")]),
                        _vm._v(" "),
                        _c("h1", [_vm._v("für Ihr Geschäftsmodell")]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout md-gutter md-alignment-top-center"
                          },
                          [
                            _vm._l(_vm.recommendations, function(item) {
                              return _c(
                                "div",
                                {
                                  key: item.hash,
                                  staticClass:
                                    "md-layout-item md-size-100 md-medium-size-100 md-small-size-100 md-xsmall-size-100",
                                  staticStyle: { "margin-top": "10px" }
                                },
                                [
                                  _c(
                                    "router-link",
                                    {
                                      staticClass: "no-link",
                                      attrs: {
                                        to: {
                                          name: "TechnologyDetail",
                                          params: { hash: item.hash }
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "md-card",
                                        {
                                          staticClass:
                                            "margin-twenty md-alignment-top-center md-elevation-1",
                                          attrs: { "md-with-hover": "" }
                                        },
                                        [
                                          _c(
                                            "md-card-header",
                                            { staticClass: "md-title" },
                                            [
                                              _c("md-card-header-text", [
                                                _vm._v(_vm._s(item.name))
                                              ]),
                                              _vm._v(" "),
                                              _c("md-card-media", [
                                                item.image != "undefined"
                                                  ? _c("img", {
                                                      attrs: {
                                                        "item.image": "",
                                                        src:
                                                          "/static/uploads/" +
                                                          item.image
                                                      }
                                                    })
                                                  : _vm._e()
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("md-card-content", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.shorten(item.description)
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _vm.recommendations.length == 0
                              ? _c("div", [
                                  _vm._v(
                                    "\n              Aktuell gibt es zu diesem Geschäftsmodell keine Empfehlungen.\n            "
                                  )
                                ])
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "md-dialog-actions",
                          [
                            _c(
                              "md-button",
                              {
                                staticClass: "md-primary",
                                on: {
                                  click: function($event) {
                                    _vm.setRecommendationsActive = false
                                  }
                                }
                              },
                              [_vm._v("Schließen")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("md-dialog-confirm", {
                attrs: {
                  "md-active": _vm.setDoneActive,
                  "md-title":
                    "Dieses Geschäftsmodell als 'Fertig' kennzeichnen?",
                  "md-content":
                    "In der Übersicht Ihrer Geschäftsmodelle wird dieses Modell als 'Fertig' gekennzeichnet.",
                  "md-confirm-text": "Fertig",
                  "md-cancel-text": "Abbrechen"
                },
                on: {
                  "update:mdActive": function($event) {
                    _vm.setDoneActive = $event
                  },
                  "update:md-active": function($event) {
                    _vm.setDoneActive = $event
                  },
                  "md-cancel": _vm.onCancel,
                  "md-confirm": _vm.onConfirm
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("md-dialog-confirm", {
        attrs: {
          "md-active": _vm.setNotDoneActive,
          "md-title":
            "Dieses Geschäftsmodell wieder als 'in Bearbeitung' kennzeichnen?",
          "md-content":
            "In der Übersicht Ihrer Geschäftsmodelle wird dieses Modell als 'in Bearbeitung' gekennzeichnet.",
          "md-confirm-text": "Ok",
          "md-cancel-text": "Abbrechen"
        },
        on: {
          "update:mdActive": function($event) {
            _vm.setNotDoneActive = $event
          },
          "update:md-active": function($event) {
            _vm.setNotDoneActive = $event
          },
          "md-cancel": _vm.onCancelNot,
          "md-confirm": _vm.onConfirmNot
        }
      }),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.customAdd },
          on: {
            "update:mdActive": function($event) {
              _vm.customAdd = $event
            },
            "update:md-active": function($event) {
              _vm.customAdd = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "10px" } },
            [
              _c("md-dialog-title", [
                _c("strong", [_vm._v("Neuen Aspekt erstellen")])
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("label", [_vm._v("Name des neuen Aspekts")]),
              _vm._v(" "),
              _c(
                "md-field",
                [
                  _c("md-input", {
                    attrs: { maxlength: "100" },
                    model: {
                      value: _vm.aspecttoadd.name,
                      callback: function($$v) {
                        _vm.$set(_vm.aspecttoadd, "name", $$v)
                      },
                      expression: "aspecttoadd.name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "md-dialog-actions",
                [
                  _vm.aspecttoadd.name != ""
                    ? _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          on: {
                            click: function($event) {
                              return _vm.addToElementInstances()
                            }
                          }
                        },
                        [_vm._v("Speichern")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "md-layout-item md-size-50 md-medium-size-100 md-small-size-100 md-xsmall-size-100"
      },
      [
        _c("p", { staticStyle: { "margin-left": "20px" } }, [
          _c("strong", [
            _vm._v(
              "Nachdem Sie die Fragen zu Ihrem Geschäftsmodell bentwortet haben,\n            können Sie die einzelnen Bausteine noch individueller an Ihr\n            Unternehmen anpassen. Klicken Sie dazu einfach auf den\n            entsprechenden Baustein."
            )
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b72e93de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b72e93de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/businessmodel/BusinessModel.vue
// module id = null
// module chunks = 